import { FC, useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import styled from 'styled-components'
import { ClockInOutWarnings } from './Warnings'
import { getStatus } from './utils'
import {
  ClockInTeamMember,
  RotaEventInstance,
  ClockIn,
} from 'screens/Rostering/types'

export const Status: FC<{
  revisionDetail: RotaEventInstance
  teamMember: ClockInTeamMember
}> = ({ revisionDetail, teamMember }) => {
  const { teamMemberId } = teamMember

  const { t } = useTranslation()

  const clockInOutDetails = useMemo(
    () =>
      revisionDetail?.clockIns?.find(
        (clockIn: ClockIn) => clockIn.teamMemberId === teamMemberId
      ),
    [revisionDetail, teamMemberId]
  )

  const status = getStatus({ clockInOutDetails })

  return (
    <StatusContainer>
      <ClockInOutWarnings warnings={teamMember.warnings} />
      <span>{t(status.label)}</span>
      {status.icon}
    </StatusContainer>
  )
}

const StatusContainer = styled.div`
  display: flex;
  margin-left: auto;
  align-items: center;
  gap: 4px;
  margin-right: 16px;
`
